(()=>{
  const start=root=>{
    if(!root||root.dataset.termsReady)return;
    root.dataset.termsReady='true';
    const links=[...root.querySelectorAll('.mrt-toc a')];
    const setCurrent=id=>links.forEach(link=>{
      if(link.hash===`#${id}`)link.setAttribute('aria-current','location');
      else link.removeAttribute('aria-current');
    });
    const mobile=root.querySelector('.mrt-mobile-toc');
    root.addEventListener('click',event=>{
      const link=event.target.closest('a[href^="#mrt-"]');
      if(!link)return;
      if(mobile&&mobile.contains(link))mobile.open=false;
      setCurrent(link.hash.slice(1));
    });
    if(!('IntersectionObserver' in window))return;
    const observer=new IntersectionObserver(entries=>{
      const visible=entries.filter(entry=>entry.isIntersecting).sort((a,b)=>a.boundingClientRect.top-b.boundingClientRect.top);
      if(visible.length)setCurrent(visible[0].target.id);
    },{rootMargin:'-90px 0px -55% 0px',threshold:0});
    root.querySelectorAll('.mrt-clause').forEach(section=>observer.observe(section));
    root.addEventListener('mr:terms-unload',()=>observer.disconnect(),{once:true});
  };
  document.querySelectorAll('.mr-terms').forEach(start);
  if(window.mrTermsEditorListener)return;
  window.mrTermsEditorListener=true;
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.mr-terms').forEach(start));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.mr-terms').forEach(root=>root.dispatchEvent(new Event('mr:terms-unload'))));
})();
